import { http } from 'http';
// import NProgressApp from 'utils/nprogress';

// Request interceptor
http.interceptors.request.use(
  config => {
    const loading = config.loading !== undefined ? config.loading : true;
    if (loading) {
      // NProgressApp.start();
    }
    config.headers['Client-GUID'] = process.env.APP_BFF_CLIENT_GUID;
    config.headers['Client-ID'] = process.env.APP_BFF_CLIENT_ID;
    return config;
  },
  error => Promise.reject(error.data)
);

// Response interceptor
http.interceptors.response.use(
  response => {
    const loading = response.config.loading !== undefined ? response.config.loading : true;
    if (loading) {
      // NProgressApp.done();
    }
    return Promise.resolve(response);
  },
  error =>
    // NProgressApp.done();

    // Do something with response error
    Promise.reject(error)
);
